import { RoundedBox } from '@react-three/drei';
import React, { useEffect, useState } from 'react'
import useStore from '../hooks/Store'
import useTimer from '../hooks/Timer';

export const StartBtn = (props) => {
    const position = [-.3, 1.56, 1.3];

    /* eslint-disable no-unused-vars */
    const [isTimerOn, countdown, isExpired, startCountdown, stopCountdown, resetCountdown] = useTimer(20)

    const [hovered, hover] = useState(false);
    const { actions } = useStore();

    useEffect(() => {
        actions.setCountdown(isExpired ? 0 : countdown)
    }, [countdown, isExpired, actions])

    useEffect(() => {
        document.body.style.cursor = !isTimerOn && hovered ? 'pointer' : 'auto'
    }, [hovered, isTimerOn])
    return (
        <RoundedBox steps={1} smoothness={1}  args={[.12, .1, .11]} radius={0.01}
            position={position}
            castShadow
            onClick={() => {
                if (!isTimerOn) {
                    resetCountdown()
                    startCountdown()
                    actions.resetScore()
                }
            }}
            onPointerOver={(event) => hover(true)}
            onPointerOut={(event) => hover(false)}
        >
            <meshPhongMaterial
                emissiveIntensity={countdown === 0 ? .5 : 0} emissive={0xff0000}
                color={hovered ? 0xa0afff : 0x88aaff}
                specular={0xffffff} shininess={20} />
        </RoundedBox>
    )
}
export default StartBtn;